import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { UpdateCrecaTradesService } from "@/features/accounts/creca/services/update-trades-service";
import { PostCrecaTradesResponseModel } from "@/features/accounts/creca/services/update-trades-model";


export const useUpdateCrecaTrades = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  const updateCrecaTradesService = new UpdateCrecaTradesService();
  
  // クレカ明細更新
  const updateCrecaTrades = async (
    accountGroupId: string,
    crecaAccountId: string,
  ): Promise<PostCrecaTradesResponseModel | undefined> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await updateCrecaTradesService.updateCrecaTrades({
        account_group_id: accountGroupId,
        creca_account_id: crecaAccountId,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("updateCrecaTrades:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updateCrecaTrades: errorHandledAsync(updateCrecaTrades, setError),
  };
};
